import { ConfirmBody, ConfirmModalWrapper, PopupBody, PopupContainer, PopupFooter, PopupModal } from "./Components";
import Button from "../Form/Button/Button";
import { useTranslation } from "react-i18next";
import {Container as BaseContainer} from "react-bootstrap"
import { useApp } from "../../hooks/useApp";
import { useModal } from "../../hooks/useModal";
export default function ConfirmPopup({children, onOk, onCancel, okLabel, cancelLabel}){
    const {closeConfirmModal} = useModal();
    const {language} = useApp();
    const {t} = useTranslation();
    const onCancelHandler = (e) => {
        closeConfirmModal();
        if(onCancel) return onCancel();
    }
    const onOkHandler = (e) => {
        closeConfirmModal();
        if(onOk) return onOk();
    }
    return (
        <PopupContainer className={language}>
            <BaseContainer>
                <PopupModal className="confirm">
                    <ConfirmModalWrapper>
                        <PopupBody>
                            <ConfirmBody>
                                {children}
                            </ConfirmBody>
                        </PopupBody>
                        <PopupFooter>
                            {onOk && <Button variant={"primary"} onClick={onOkHandler}>{okLabel??t("OK")}</Button>}
                            {onCancel && <Button variant={"outline-primary"} onClick={onCancelHandler}>{cancelLabel??t("Cancel")}</Button>}
                        </PopupFooter>
                    </ConfirmModalWrapper>
                </PopupModal>
            </BaseContainer>
            
        </PopupContainer>
    )
}